import { create } from "zustand";
import { ReactNode } from "react";

interface PageHeaderState {
  title: string;
  description?: ReactNode;
  actions?: ReactNode;
  setTitle: (title: string) => void;
  setDescription: (desc: ReactNode) => void;
  setActions: (actions: ReactNode) => void;
  reset: () => void;
}

export const usePageHeaderStore = create<PageHeaderState>((set) => ({
  title: "",
  description: undefined,
  actions: undefined,
  setTitle: (title) => set({ title }),
  setDescription: (description) => set({ description }),
  setActions: (actions) => set({ actions }),
  reset: () => set({ title: "", description: undefined, actions: undefined }),
})); 